const keys = {};
const byIds = {};

export class QualificationTypeEnum {
  constructor(id, value, label) {
    this.id = id;
    this.value = value;
    this.label = label;
    keys[value] = this;
    byIds[id] = this;
  }

  equals(value) {
    if (typeof value === 'string') {
      return this.value === value;
    } else if (typeof value === 'object' && value.hasOwnProperty('value')) {
      return this.value === value.value;
    } else {
      return false;
    }
  }

  static get(value) {
    if (keys[value]) {
      return keys[value];
    }
    return null;
  }

  static getById(id) {
    if (byIds[id]) {
      return byIds[id];
    }
    return null;
  }
}

QualificationTypeEnum.GENERAL = new QualificationTypeEnum(
  1,
  'general',
  'General'
);
QualificationTypeEnum.TRADE = new QualificationTypeEnum(2, 'trade', 'Trade');
QualificationTypeEnum.OTHER = new QualificationTypeEnum(3, 'other', 'Other');



// WEBPACK FOOTER //
// ./src/domain/qualification-type-enum.js